module.exports = __webpack_public_path__ + "static/media/Tommel.57d92930.PNG";